import React from "react";
import { css } from "aphrodite";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import { GoogleMapStyle, mapContainerStyle } from "./GoogleMapStyle";
import { GOOGLE_API_KEY } from "main/javascripts/constants/Constants";

export interface IProps {
  google?: any;
  latitude: number;
  longitude: number;
}

const GoogleMapComponent: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { google, latitude, longitude } = props;

  return (
    <div className={css(GoogleMapStyle.googleMap)}>
      <Map
        containerStyle={mapContainerStyle}
        google={google}
        zoom={14}
        streetViewControl={false}
        fullscreenControl={true}
        mapTypeControl={false}
        initialCenter={{
          lat: latitude,
          lng: longitude,
        }}
      >
        <Marker />
      </Map>
    </div>
  );
};
export const GoogleMap: any = GoogleApiWrapper({
  apiKey: GOOGLE_API_KEY,
  language: "ja",
  region: "JP",
})(GoogleMapComponent);
